module.exports = __webpack_public_path__ + "img/0.7c5b6883.svg";